import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-conflict-of-interest-form',
    templateUrl: './conflict-of-interest-form.component.html',
})
export class ConflictOfInterestFormComponent {
    @Input({ required: true }) form!: FormGroup;

    areas = ['Áhættustýring', 'Eignastýring', 'Fjármálasvið', 'Lánasvið', 'Lífeyrissvið', 'Stafræn þróun og rekstur', 'Stjórn'];

    projectTypes = [
        'Viðskipti með fjármálagerninga',
        'Úrvinnsla lánamáls',
        'Úrskurður lífeyris',
        'Vöru- eða þjónustukaup',
        'Samningur við verktaka',
        'Annað',
    ];
}
